import { render } from "./NavContainer.vue?vue&type=template&id=47c514f4&scoped=true"
import script from "./NavContainer.vue?vue&type=script&lang=js"
export * from "./NavContainer.vue?vue&type=script&lang=js"

import "./NavContainer.vue?vue&type=style&index=0&id=47c514f4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-47c514f4"

export default script